import type { RoomType } from 'frontend-utils/models/roomtype';
import type { Platform } from 'frontend-utils/utils/constants/constant-values';
import type {
  CompareType,
  MealTypeValues,
  MembershipType,
  RateParam,
} from 'lumen/utils/constants/general-constants';

export const DETAIL_TABS = {
  PRICING: 'pricing', // Pricing assistant day detail tab
  RATE_EVOLUTION: 'rate-evolution',
  BOOKING_CURVE: 'booking-curve',
};

// Note: The PA & rates logic is split into separate routes, but we still use this for the viewswitcher button in both routes
export const RATES_PAGE_MODES = {
  RATES: 'rates',
  PRICING: 'pricing',
} as const;

export const RATES_VIEWS = {
  CALENDAR: 'calendar',
  CHART: 'chart',
  TABLE: 'table',
};

export type RatesView = (typeof RATES_VIEWS)[keyof typeof RATES_VIEWS];

export const DAYS_OF_DEMAND_DATA = 60;
export const DAYS_OF_DEMAND_DATA_FOR_MI_SUBS = 365;

export const RATE_COLUMNS = {
  HISTORY: 'history',
  DATE: 'date',
  MY_OTB: 'myotb',
  MARKET_OTB: 'marketotb',
  MARKET_DEMAND: 'market-demand',
  SHORT_TERM_RENTAL_OTB: 'short-term-rental-otb',
  SHORT_TERM_RENTAL_RATE: 'short-term-rental-rate',
} as const;

export type requestParams = {
  compareType: CompareType;
  compareValue: string;
  compsetId: string;
  los: number;
  maxPersons: number;
  mealPlan: MealTypeValues;
  membershipType: MembershipType;
  otaId: string;
  platform: Platform;
  rateParam: RateParam;
  roomType: RoomType;
  view: RatesView;
};

export const TABLE_COMPARISON_LAYOUT = {
  SEPARATE_ROW: 'separate-row',
  SIDE_BY_SIDE: 'side-by-side',
} as const;

export type TableComparisonLayout =
  (typeof TABLE_COMPARISON_LAYOUT)[keyof typeof TABLE_COMPARISON_LAYOUT];

// Rates table comparison default layout if no user preference is found in local storage
export const TABLE_COMPARISON_LAYOUT_DEFAULT: TableComparisonLayout =
  TABLE_COMPARISON_LAYOUT.SEPARATE_ROW;
